<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.26562 35.8455C4.31174 30.8764 8.70861 27.25 13.7977 27.25H26.2014C31.2905 27.25 35.6873 30.8764 36.7335 35.8455L35.2656 36.1545C34.3633 31.8687 30.5701 28.75 26.2014 28.75H13.7977C9.42902 28.75 5.63573 31.8687 4.73345 36.1545L3.26562 35.8455Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8759 11.4532C11.1057 6.8579 14.8985 3.25 19.4995 3.25C24.1006 3.25 27.8934 6.8579 28.1231 11.4532L28.2505 14L28.1231 16.5468C27.8934 21.1421 24.1006 24.75 19.4995 24.75C14.8985 24.75 11.1057 21.1421 10.8759 16.5468L10.7486 14L10.8759 11.4532ZM19.4995 4.75C15.6978 4.75 12.5639 7.73112 12.3741 11.5281L12.2505 14L12.3741 16.4719C12.5639 20.2689 15.6978 23.25 19.4995 23.25C23.3013 23.25 26.4352 20.2689 26.625 16.4719L26.7486 14L26.625 11.5281C26.4352 7.73112 23.3013 4.75 19.4995 4.75Z"
      class="fill-current"
    />
  </svg>
</template>
